import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
// TODO: сделать карточку пользователя модулем верхнего уровня
import { InviteToClassroomModule } from '@app/classrooms/_components/invite-to-classroom/invite-to-classroom.module';
import { PaginationModule } from '@app/core/components/pagination/pagination.module';
import { UserCardMiniModule } from '@app/users/user-card-mini/user-card-mini.module';
import { MobileModalModule } from '@core/components/mobile-modal/mobile-modal.module';
import { ModalModule } from '@core/components/modal/modal.module';
import { NoContentStubComponent } from '@core/components/no-content-stub/no-content-stub.component';
import { TranslateModule } from '@ngx-translate/core';
import { ClassroomParticipantsPageComponent } from './classroom-participants-page.component';

@NgModule({
  declarations: [ClassroomParticipantsPageComponent],
  imports: [
    CommonModule,
    TranslateModule,
    UserCardMiniModule,
    PaginationModule,
    ModalModule,
    MobileModalModule,
    InviteToClassroomModule,
    NoContentStubComponent,
  ],
  exports: [ClassroomParticipantsPageComponent],
})
export class ClassroomParticipantsPageModule {}
